import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { Fonts } from '../../../styles/styles';

const { colors, space } = THEME;

export const styleSheet = StyleSheet.create({
	compactFlag: {
		position: 'absolute',
		right: 0,
		top: space[4],
	},
	container: {},
	flag: {
		marginLeft: 10,
	},
	icon: {
		display: 'flex',
		height: 20,
		justifyContent: 'center',
		textAlign: 'center',
		verticalAlign: 'middle',
		width: 22,
	},
	linkName: {
		fontFamily: Fonts.lexend,
		marginLeft: 15,
	},
	linkNameOutlined: {
		border: `1px solid ${colors.primary.main}`,
		borderRadius: 3,
		padding: '4px 10px',
	},
});
